import {fire} from '../Libraries/helpers.js';

export const basketNotifier = () => {
    return {
        duration: 5000,
        visible: false,
        item: {},
        currentVariantId: null,
        _timeout: null,

        init() {
            // Listen for our custom event but check if it's intended for this instance
            window.addEventListener('basket-notifier', (event) => {
                if (this.$el.dataset.variantId && event.detail.variantId === parseInt(this.$el.dataset.variantId)) {
                    this.show(event.detail);
                }
            });
        },

        show(options) {
            this.currentVariantId = options.variantId;
            this.item = {...this.item, ...options};
            this.visible = true;

            clearTimeout(this._timeout);
            this._timeout = setTimeout(() => {
                this.visible = false;
                this.currentVariantId = null;
            }, this.duration);
        },

        toggle() {
            this.visible = !this.visible;
        },
    };
};

// Help fire our event via twig and in js globally
window.addToBasket = (item = null) => {
    if (item) {
        // Dispatch the event with all the necessary data
        window.dispatchEvent(
            new CustomEvent('basket-notifier', {
                detail: item,
            }),
        );

        fire('stickit');
    }
};
